import React, { PureComponent } from 'react';
import T from 'prop-types';
// components
import { Collapse } from 'react-collapse';
import ModuleInclude from '../ModuleInclude/ModuleInclude';
import Icon from '../Icon/Icon';
// styles
import styles from './ModuleDescription.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class ModuleDescription extends PureComponent {
  constructor(props) {
    super(props);
    const closedModules = this.getClosedModulesLS();
    this.state = {
      isOpened: !closedModules.includes(props.module.id),
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isOpened: false });
    }, 5000);
  }

  getClosedModulesLS = () =>
    JSON.parse(window.localStorage.getItem('closed_modules')) || [];

  toggleCollapseCallback = () => {
    const { module } = this.props;
    const { isOpened } = this.state;
    const closedModules = this.getClosedModulesLS();
    const updatedModules = isOpened
      ? closedModules.filter(id => id !== module.id)
      : [...closedModules, module.id];

    localStorage.setItem('closed_modules', JSON.stringify(updatedModules));
  };

  toggleCollapse = () =>
    this.setState(
      prevState => ({
        isOpened: !prevState.isOpened,
      }),
      this.toggleCollapseCallback
    );

  render() {
    const { module, className } = this.props;
    const { isOpened } = this.state;

    const { title, description } = module;

    return (
      <div className={cn('wrapper', className)}>
        <div className={cn('heading')} onClick={this.toggleCollapse}>
          <h2 className={cn('title')}>{title}</h2>
          <Icon
            type="chevron-up"
            className={cn('chevron', { rotated: !isOpened })}
          />
        </div>
        <Collapse isOpened={!!isOpened}>
          <div className={cn('flexRow', 'row')}>
            <div className="col-sm-7">
              <h4 className="mb-15">Introduction</h4>
              <div>{description}</div>
            </div>
            <div className="col-sm-5">
              <h4 className="mb-15">Module include</h4>
              <ModuleInclude module={module} />
            </div>
          </div>
        </Collapse>
        <hr className={cn('divider')} />
      </div>
    );
  }
}

ModuleDescription.propTypes = {
  className: T.string,
  isOpened: T.bool,
  module: T.shape({
    id: T.number.isRequired,
    title: T.string.isRequired,
    description: T.string.isRequired,
  }),
};

export default ModuleDescription;



// WEBPACK FOOTER //
// ./src/components/ModuleDescription/ModuleDescription.jsx